
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#42A5B2","d":"M62 41H2v17a4 4 0 004 4h52a4 4 0 004-4V41z"}}),_c('path',{attrs:{"fill":"#62C4C3","d":"M52 21H12L2 41h60z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M17 27a2 2 0 00-2 2v2a2 2 0 002 2h30a2 2 0 002-2v-2a2 2 0 00-2-2H17z"}}),_c('path',{attrs:{"fill":"#F2DAAE","d":"M19 33V2h12.586c.905 0 1.774.359 2.414 1 .64.641 1.509 1 2.414 1H45v29H19z"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M40 51c0 2.762-3.582 5-8 5s-8-2.238-8-5 3.582-5 8-5 8 2.238 8 5z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M57 44h2v2h-2zM53 44h2v2h-2zM49 44h2v2h-2z"}}),_c('path',{attrs:{"fill":"#E0C494","d":"M45 18.659c-4.842 6.004-15.648 10.278-26 11.164V33h26V18.659z"}})])
          )
        }
      }
    